import React from 'react';
import { ECardType } from '../../Enums/ECardType.enum';
// @ts-ignore
import styles from './ECardInfoText.module.scss';
import Text from '../../../../Components/Base/Text/Text';

interface Props {
	eCardType: ECardType;
}
const ECardInfoText: React.FC<Props> = ({ eCardType }) => (
	<Text
		tx={
			eCardType === ECardType.PATIENT_E_CARD
				? 'component.eCard.eCardLabel'
				: 'component.eCard.healthDocumentationLabel'
		}
		className={styles.text}
	/>
);

export default ECardInfoText;
